import React from "react";

type FormLabelProps = {
    text: string;
}
export const FormHeader: React.FC<FormLabelProps> = (props) => {
    return <h2 className="text-md text-left font-semibold">{props.text}</h2>

}